import l from "./index477.js";
import { resolveComponent as n, createBlock as a, openBlock as s, resolveDynamicComponent as p, normalizeClass as d, withCtx as m, createCommentVNode as t, createElementVNode as o, createElementBlock as f, renderSlot as h, toDisplayString as g } from "vue";
/* empty css         */
import k from "./index231.js";
const u = { class: "ms-textLink__textWrapper" }, c = { class: "ms-textLink__text" }, y = {
  key: 2,
  class: "ms-textLink__suffix"
};
function L(e, v, C, G, P, R) {
  const r = n("SvgAnchor"), i = n("SvgArrow");
  return s(), a(p(e.isPRG ? "span" : "a"), {
    class: d(["ms-textLink", {
      "-anchorLink": e.isIndex,
      "-clickArea": e.hasClickArea,
      "-copylink": e.isCopyLink,
      "-hyphens": e.hyphensEnabled,
      "-truncated": e.isTruncated
    }]),
    href: e.isPRG ? !1 : e.href,
    target: e.isPRG ? !1 : e.target,
    rel: !e.isPRG && e.rel ? e.rel : !1,
    "data-component": e.$options.name,
    "data-mod": e.isPRG ? "prg" : !1,
    "data-prg-href": e.isPRG ? e.href : null,
    "data-sign": e.isPRG ? e.sign : null,
    "data-target": e.isPRG ? e.target : null
  }, {
    default: m(() => [
      e.hasAnchorIcon ? (s(), a(r, {
        key: 0,
        class: "ms-textLink__svg"
      })) : !e.isCopyLink && !e.isIndex ? (s(), a(i, {
        key: 1,
        class: "ms-textLink__svg"
      })) : t("", !0),
      o("span", u, [
        o("span", c, [
          h(e.$slots, "default", {}, void 0, !0)
        ])
      ]),
      e.suffix !== null ? (s(), f("span", y, g(e.suffix), 1)) : t("", !0)
    ]),
    _: 3
  }, 8, ["class", "href", "target", "rel", "data-component", "data-mod", "data-prg-href", "data-sign", "data-target"]);
}
const _ = /* @__PURE__ */ k(l, [["render", L], ["__scopeId", "data-v-38ea909b"]]);
export {
  _ as default
};
